import User from 'entities/user/model';

const calculateChecksum = (userId: string, organizationId: string): string => {
  const combinedIds = userId + organizationId;
  const sum = combinedIds.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
  return (sum % 65536).toString(16).padStart(4, '0');
};

export const generateEncodedEmailBody = ({
  user,
  emailBody,
}: {
  user: User;
  emailBody: string;
}): string => {
  const { fullName } = user?.toJS();

  const checksum = calculateChecksum(user.id, user.organization.id);

  const platformInfo = `
--- BEGIN DEED PLATFORM INFORMATION V1 ---
Please do not edit this section as it will slow down the processing of your request.
User Name : ${fullName.first} ${fullName.last}
User Email : ${user.email}
Organization Name : ${user.organization.name}
User ID : ${user.id}
Organization ID : ${user.organization.id}
Checksum : ${checksum}
--- END DEED PLATFORM INFORMATION V1 ---
    `;

  const wrappedEmailBody = `
Hello Deed Support Team,

${fullName.first} ${fullName.last} here contacting you from ${user.organization.name}.

${emailBody}

Best regards,
${fullName.first} ${fullName.last}
${user.organization.name}
[Any additional contact information]

${platformInfo}
`;

  return encodeURIComponent(wrappedEmailBody);
};

export const generateEmailLink = ({
  recipient,
  subject,
  emailBody,
}: {
  recipient: string;
  subject: string;
  emailBody: string;
}): string => `mailto:${recipient}?subject=${encodeURIComponent(subject)}&body=${emailBody}`;
